export function sanitizeTextInput(inputValue: string | null): string | null {
  return inputValue === null || inputValue.split("").every((char) => char === " ") || inputValue === ""
    ? null
    : inputValue
}
